import { useCallback } from 'react';
import { openPageNative } from '@/utils/bridge';
import { reportClick } from '@/utils/report';
import { RECOMMEND_DEVICE_LIST } from '../../config';
import styles from '../index.less';

const RecommendDeviceList = ({ pageName }) => {
  const handleJumpToBuy = useCallback(
    item => {
      const { link, deviceType } = item;
      reportClick({ page_name: pageName, button_name: 'to_buy', deviceType });
      if (link) openPageNative({ url: link });
    },
    [pageName]
  );

  return (
    <div className={styles.recommendPart}>
      <h4 className={styles.recommendTitle}>购机领迅雷会员</h4>
      <ul className={styles.recommendList}>
        {RECOMMEND_DEVICE_LIST.map(item => (
          <li
            key={item.deviceType}
            className={styles[item.prefix]}
            onClick={() => handleJumpToBuy(item)}
          >
            <div className={styles.infoWrapper}>
              <div className={styles.deviceInfo}>
                <p className={styles.deviceType}>{item.deviceType}</p>
                <p className={styles.reward}>{item.reward}</p>
                <p className={styles.income}>
                  <em>{item.income}</em>至高可赚
                </p>
              </div>
              <button className={styles.recommendBtn}>立即购买</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecommendDeviceList;
